import { ThemeUIStyleObject } from "theme-ui";
import { getThemeValue } from "@styles/utils/getThemeValue";
import { cssTransitions } from "@styles/design-tokens/09.transitions/transitions";

export const buttonTextStyles: ThemeUIStyleObject = {
  position: "relative",
  color: "inherit",
  letterSpacing: "3px",
  fontFamily: "heading",
  fontSize: "smText",
  textTransform: "uppercase",
  minWidth: "142px",
  maxWidth: "100%",
  transition: "color .3s ease-in-out",
  display: "inline-block",
};
export const buttonSharedStyles: ThemeUIStyleObject = {
  position: "relative",
  overflow: "hidden",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  px: "6",
  py: "4",
  cursor: "pointer",
  letterSpacing: "wide",
  textAlign: "center",
  transition: cssTransitions.fast,
  borderWidth: "4",
  borderStyle: "solid",
  maxWidth: "100%",
  borderRadius: 0,
};

export const buttonHoverAnimation: ThemeUIStyleObject = {
  backgroundImage:
    "linear-gradient(to bottom, transparent 0%, transparent 50%, currentColor 50%, currentColor 100%)",
  backgroundSize: "130% 210%",

  backgroundPosition: "1% 100%",
  transition: "background-position 0.3s",

  "&:hover, &:focus": {
    backgroundPosition: "0 0",
    boxShadow: "none",
  },
};

export const buttonOutlineStyle: ThemeUIStyleObject = {
  borderWidth: "4",
  borderStyle: "solid",

  backgroundImage:
    "linear-gradient(to bottom, transparent 0%, transparent 50%, currentColor 50%, currentColor 100%)",
  backgroundSize: "130% 210%",

  backgroundPosition: "0 0%",
  transition: "background-position 0.3s",

  "&:hover, &:focus": {
    backgroundPosition: "10% 99%",
    boxShadow: "none",
  },
};

export const buttonShadowStyle: ThemeUIStyleObject = {
  boxShadow: "floating",
};
export const buttonShadowWhiteFocusStyle: ThemeUIStyleObject = {
  boxShadow: "floating",
  "&:focus": {
    boxShadow: `${getThemeValue(
      "shadows.floating"
    )}, 0 0 0 2px rgba(255,255,255,0.5)}`,
  },
};

export const buttonPillStyle: ThemeUIStyleObject = {
  borderRadius: "pill",
};

export const buttonRoundStyle: ThemeUIStyleObject = {
  borderRadius: "full",
  p: "4",
  letterSpacing: "normal",
};

export const buttonHollowCircleStyles: ThemeUIStyleObject = {
  ...buttonRoundStyle,
  p: "2",
  fontSize: "paragraphSmall",
  borderWidth: 2,
  borderStyle: "solid",
  "&:before": {
    content: "none",
  },
};

export const buttonRoundSmallStyle: ThemeUIStyleObject = {
  ...buttonRoundStyle,
  p: "2",
  fontSize: "paragraphSmall",
};

export const buttonHexagonStyle: ThemeUIStyleObject = {
  position: "relative",
  borderRadius: 0,
  border: "none",
  p: "0",
  bg: "transparent",
  width: 52,
  height: 56,
  overflow: "hidden",
  stroke: "brownDark",
  "&:hover": {
    bg: "transparent",
    color: "brownDark",
  },
  "&:focus": {
    boxShadow: "none",
  },
  "::before": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate3d(-50%, -50%, 0)",
    content: '""',
    width: 35,
    height: 35,
    boxShadow: "floating",
    zIndex: -1,
  },
};
export const buttonHexagonOutlineStyle: ThemeUIStyleObject = {
  ...buttonHexagonStyle,
  width: "65px",
  height: "65px",
  fontSize: "paragraphLarge",
  "::before": {
    display: "none",
  },
  "&:hover, &:focus, &:active": {
    color: "white", // reset variant styling - for now hexagon outlines are always white
  },
};
export const buttonHexagonIconStyle: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: "100%",
  height: "100%",
  "~ *": {
    zIndex: "1",
  },
  "&:hover, &:focus, &:active": {
    color: "darkGreen", // reset variant styling - for now hexagon outlines are always white
  },
};
